<template>
  <div class="block" ref="chosenPaymentMethodField">
    <div class="block-title left">
      <h3 :class="getErrorClass('chosenPaymentMethod', 'invalid-text')">
        <i v-if="getValidationError('chosenPaymentMethod')">
          <font-awesome-icon icon="fa-solid fa-triangle-exclamation" />
        </i>
        Выберите вариант оплаты доставки:
      </h3>
    </div>
    <div class="pay-type">
      <label v-for="(method, index) in formattedPaymentMethods" :key="index">
        <input
          :disabled="!method.isActive"
          v-model="chosenPaymentMethod"
          :value="method.value"
          name="payment-method"
          type="radio"
          id="chosenPaymentMethod"
          ref="chosenPaymentMethod"
        />
        <span :class="{ 'disabled-span': !method.isActive }">
          {{ method.name }}
        </span>
        <i
          v-if="method.prompt"
          class="icon-tooltip"
          v-tooltip.top-center="{
            content: method.prompt,
            trigger: 'hover click',
          }"
        ></i>
      </label>
    </div>
  </div>
</template>

<script>
import paymentMethodMixin from '@apps/order-form/src/mixins/paymentMethod'

export default {
  name: 'PaymentMethod',
  mixins: [paymentMethodMixin],
}
</script>

<style lang="scss" scoped>
h3 {
  font-size: inherit;
}

.block {
  margin-top: 20px;

  &-title h3 {
    display: inline-flex;
    align-items: center;

    &.invalid-text {
      i {
        margin-right: 6px;

        font-size: 20px;
      }
    }
  }
}

.label {
  @media (min-width: 768px) {
    max-width: 60%;
  }
}

.disabled-span {
  cursor: default;

  opacity: 0.4;
}

input:disabled {
  cursor: default !important;
}
</style>
